import type { AssistantResponseSources } from "../../types/provenance";

/**
 * Shared tier counts (Searched ⊇ Read ⊇ Cited) for the Sources panel and the
 * per-response summary line. Searched = DISTINCT collections queried.
 */
export const countProvenanceTiers = (provenance: AssistantResponseSources) => {
  const unavailable = provenance.unavailable_sources ?? [];
  const external = provenance.external_sources ?? [];
  const citedExternal = external.filter((e) => e.cited);
  // Read tier shows every external — all were read into context; the cited ones
  // ALSO appear in Cited (nested funnel).
  const readExternal = external;
  // Collection identity - live streamed entries carry only dataset ids;
  // entries with neither (web/general search) share a single unnamed bucket.
  const searchedCollections = new Set<string>();
  for (const s of provenance.searched) {
    if (s.collection_names?.length) {
      for (const name of s.collection_names) {
        searchedCollections.add(`name:${name}`);
      }
    } else if (s.dataset_ids?.length) {
      for (const id of s.dataset_ids) searchedCollections.add(`id:${id}`);
    } else {
      searchedCollections.add("__unnamed__");
    }
  }
  return {
    citedCount:
      provenance.assistant_response_sources.length +
      unavailable.filter((u) => u.cited).length +
      citedExternal.length,
    // Nested: read = read-only chunks + cited chunks + all unavailable + all
    // externals. Always ≥ citedCount.
    readCount:
      provenance.read_sources.length +
      provenance.assistant_response_sources.length +
      unavailable.length +
      external.length,
    searchedCollectionCount: searchedCollections.size,
    citedExternal,
    readExternal,
  };
};
